import { jsx as _jsx } from "react/jsx-runtime";
import { TypographyText } from '../_core';
import styles from '../typography.module.css';
const SIZE_CLASS = {
    'title-sm': styles['numeric-title-sm'],
    'title': styles['numeric-title'],
    'title-lg': styles['numeric-title-lg'],
};
/**
 * Tabular numerals for stat tiles, counters, hero figures.
 *
 * size="title-sm" → 18 (standard stat tile, DEFAULT)
 * size="title"    → 24 (hero stat)
 * size="title-lg" → 32 (dashboard hero figure)
 *
 * Sans family, weight 700, tabular-nums. Sizes match the heading scale
 * so a Numeric and a Heading of the same tier visually align.
 *
 * Do not override fontSize, fontFamily, lineHeight, fontWeight, or
 * letterSpacing via style prop.
 */
export function Numeric({ size = 'title-sm', children, style, ...rest }) {
    return (_jsx(TypographyText, { as: "span", roleClassName: SIZE_CLASS[size], style: style, ...rest, children: children }));
}
//# sourceMappingURL=Numeric.js.map